import { faCirclePlus } from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/react/macro';
import { Button, Input } from '@repo/videa-components/src/index';

interface SearchAndAddPayerProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
}

export const SearchAndAddPayer = ({
  searchQuery,
  onSearchChange,
}: SearchAndAddPayerProps) => {
  return (
    <div className="vai-px-4 vai-py-3 vai-flex vai-items-center vai-gap-2">
      <Input
        placeholder="Search Payers"
        className="vai-flex-1"
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
      />
      {/* TODO: Implement add payer functionality / get rid of it completely if not needed */}
      {/* <Button variant="outline" size="sm">
        <FontAwesomeIcon icon={faCirclePlus} />
        <Trans>Add Payer</Trans>
      </Button> */}
    </div>
  );
};
